export default {
    data() {
        return {
            jobMonitor: '',
        }
    },

    props: {
        monitor: {
            required: true
        },

        channel: {
            type: String,
            required: true,
        },

        successEvent: {
            type: String,
            required: true,
        },

        failEvent: {
            type: String,
            required: true,
        },
    },

    mounted() {
        this.jobMonitor = this.monitor;

        window.Echo.channel('job-monitor.' + this.channel)
            .listen('JobMonitorStatusUpdated', (echo) => {
                if (echo.monitor.completed + echo.monitor.errors > this.completed) {
                    this.jobMonitor = echo.monitor;
                }
            });

        bus.$on(this.successEvent, function (monitor) {
            this.jobMonitor = JSON.parse(monitor);
        }.bind(this));
    },

    computed: {
        completed() {
            return this.jobMonitor.completed + this.jobMonitor.errors;
        },

        progress() {
            let width = 0;

            if (this.jobMonitor) {
                width = (this.completed / this.jobMonitor.tasks) * 100;
            }

            return 'width:' + width + '%';
        },

        finished() {
            return this.completed == this.jobMonitor.tasks;
        },

        progressBarClasses() {
            return {
                'ProgressBar__progress': true,
                'ProgressBar__progress--in-progress': ! this.finished,
            }
        },

        monitorHasData() {
            return ! _.isEmpty(this.jobMonitor.data);
        }
    },

    methods: {
        resetForm() {
            this.jobMonitor = null;
        },
    }
}